class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
      var sortByElementBeforeFilterApply = document.getElementById('SortBy');
    

  sortByElementBeforeFilterApply.addEventListener('click', function() {
    
    if (sortByElementBeforeFilterApply.style.border === '1px solid black') {
      sortByElementBeforeFilterApply.style.border = '1px solid #ced4da';
    } else {
      sortByElementBeforeFilterApply.style.border = '1px solid black';
    }
  });

  document.addEventListener('click', function(event) {
    if (event.target !== sortByElementBeforeFilterApply) {
      sortByElementBeforeFilterApply.style.border = '1px solid #ced4da';
    }
  });


   
    const onHistoryChange = (event) => {
      
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
 
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
      
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    // sortby
    var sortByElement = document.getElementById('SortBy');
    

    sortByElement.addEventListener('click', function () {
        if (sortByElement.style.border === '1px solid black') {
            sortByElement.style.border = '1px solid #ced4da';
        } else {
            sortByElement.style.border = '1px solid black';
        }
    });
     document.addEventListener('click', function(event) {
    if (event.target !== sortByElement) {
      sortByElement.style.border = '1px solid #ced4da';
    }
  });
    
 


        const facetRemoveElements = document.querySelectorAll('#FacetsWrapperDesktop .active-facets .facet-remove-button');
        const filteredByContainer = document.querySelector('.filtered-by-container ul');


        while (filteredByContainer.hasChildNodes()) {
            filteredByContainer.removeChild(filteredByContainer.firstChild);
        }

        const removeClearAllContainer = document.querySelector('.filtered-by-container .clear-all-above-productgrid .clear-all-tag');
        removeClearAllContainer.remove();

        facetRemoveElements.forEach(element => {
            const clonedElement = element.cloneNode(true);
            const newLi = document.createElement('li');
            newLi.appendChild(clonedElement);
            filteredByContainer.appendChild(newLi);
        });


        //remove filter tag

        const facetClearAll = document.querySelector('#FacetsWrapperDesktop .active-facets .active-facets__button-wrapper');

        
        const facetContainerCheck = document.querySelector('#FacetsWrapperDesktop .active-facets');
        if (facetContainerCheck.children.length > 1) {
            const filteredByClearAll = document.querySelector('.filtered-by-container .clear-all-above-productgrid');
            const clonedElement2 = filteredByClearAll.cloneNode(true);
            const newLi2 = document.createElement('div');
            newLi2.appendChild(clonedElement2);
            filteredByClearAll.appendChild(newLi2);
            newLi2.className = 'clear-all-tag';
            newLi2.innerHTML = facetClearAll.outerHTML;
        }

        // Changing the font-weight    
        const facetsFilterTags = document.querySelectorAll('.list-unstyled li .filter-name');
        var filterName1Array = [];
        var filterName2Array = [];

        facetContainerCheck.querySelectorAll('.facet-remove-button').forEach(tag => {

            const removeSecondChild = tag.querySelector('.active-facets__button-inner span').remove();
            const selectedTag0 = tag.querySelector('.active-facets__button-inner');
            const selectedTag1 = selectedTag0.textContent.trim();
            const splitselectedTag1 = selectedTag1.split(":");
            const filterName1 = splitselectedTag1[1].trim();

            filterName1Array.push(filterName1);


        });
        document.querySelector('.filtered-by-container .clear-all-above-productgrid').addEventListener('click', function (event) {
            document.querySelector('facet-filters-form #clearAll').click();
            const containerToRemove = document.querySelector('.filtered-by-container');
            containerToRemove.remove();
            filterName1Array = [];
            $('.facet-checkbox-options-filter').prop('checked', false);

            // ✅ Re-apply availability filter after clear all
            setTimeout(function() {
                const availabilitySelectors = [
                    '[id^="Filter-filter.v.availability-1"]',
                    '[id^="Filter-filter.v.availability-mobile-1"]'
                ];
                availabilitySelectors.forEach(function(selector) {
                    const input = document.querySelector(selector);
                    if (input && !input.checked) {
                        input.checked = true;
                        input.dispatchEvent(new Event('input', { bubbles: true }));
                        document.querySelector('[id^="Filter-filter.v.availability-1"]').click();
                        document.querySelector('[id^="Filter-filter.v.availability-mobile-1"]').click();
                    }
                });
            }, 777); // slight delay to let the clear render first
        });
  }

  static renderFilters(html, event) {
    
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
         
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);

    // ✅ ADD THIS — remove availability pills after render
    FacetFiltersForm.removeAvailabilityPills();
  }

  static removeAvailabilityPills() {
    // Remove from filtered-by-container
    document.querySelectorAll('.filtered-by-container .facet-remove-button').forEach(function(pill) {
      const spanTarget = pill.querySelector('.active-facets__button-inner');
      if (spanTarget && spanTarget.textContent.toLowerCase().includes('availability')) {
        pill.remove();
      }
    });

    // Remove from desktop active facets
    document.querySelectorAll('.active-facets-desktop .active-facets__button').forEach(function(pill) {
      const spanTarget = pill.querySelector('.active-facets__button-inner');
      if (spanTarget && spanTarget.textContent.toLowerCase().includes('availability')) {
        pill.closest('facet-remove').remove();
      }
    });

    // Remove from mobile active facets
    document.querySelectorAll('.active-facets-mobile .active-facets__button').forEach(function(pill) {
      const spanTarget = pill.querySelector('.active-facets__button-inner');
      if (spanTarget && spanTarget.textContent.toLowerCase().includes('availability')) {
        pill.closest('facet-remove').remove();
      }
    });
  }

  static renderAdditionalElements(html) {
    
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
    
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

if (typeof (Colehaan) === 'undefined') {
    var Colehaan = {};
}//extra added

/**
 * Colehaan PLP Price Namespace
 */
Colehaan.PLP = {

    /**
     * Fetch the refined price list through Shopify variable.
     */
    getProducts: function (ev) {
        //ev.preventDefault();
        const selectedPrice = ev.getAttribute('data-price');
        const selectedEleFetchs = ev.className;
        const priceArray = selectedPrice.split("-");
        document.getElementById("Filter-Price-GTE").value = Math.trunc(priceArray[0]);
        document.getElementById("Filter-Price-LTE").value = Math.trunc(priceArray[1]);
        const facetForm2 = document.querySelector('facet-filters-form form');
        var customPriceEvent = new Event('input', {
            bubbles: true,
            cancelable: true,
        });
        facetForm2.dispatchEvent(customPriceEvent);
        
        localStorage.setItem("priceFilterselected", selectedEleFetchs);
        setTimeout(function() {
         
          var priceSelected = localStorage.getItem('priceFilterselected');
          var clsConverstionvari = $("."+priceSelected);
        
          if (clsConverstionvari) {
            clsConverstionvari.addClass('selectedfilter');
          }
       }, 2500); 
    }
};//extra addded
